import { useState } from 'react';
import { useApolloContext, useQuery, useMutation } from 'utils/apollo';

import { Comments } from './Comments';

import getComments from './queries/getComments.papi.gql';
import createCommentMutation from './mutations/createComment.papi.gql';
import editCommentMutation from './mutations/editComment.papi.gql';

export const useCommentMutation = mutation => {
  const { papiClient } = useApolloContext();

  return useMutation(mutation, {
    client: papiClient,
    refetchQueries: ['getComments'],
    awaitRefetchQueries: true,
  });
};

function CommentsController({ threadId, loading, ...props }) {
  const { papiClient } = useApolloContext();
  const [editId, setEditId] = useState(null);
  const { data, loading: commentsLoading } = useQuery(getComments, {
    client: papiClient,
    variables: { threadId },
    skip: !threadId,
  });
  const { comments = [] } = data || {};

  const [createComment, { loading: saveLoading }] = useCommentMutation(createCommentMutation);
  const [editComment, { loading: editLoading }] = useCommentMutation(editCommentMutation);

  const handleSave = comment => {
    createComment({ variables: { threadId, comment } });
  };

  const handleEdit = ({ id, comment }) => {
    setEditId(id);
    editComment({ variables: { id, comment } });
  };

  return (
    <Comments
      comments={comments}
      onSave={handleSave}
      onEdit={handleEdit}
      saveLoading={saveLoading}
      editLoading={editLoading}
      editId={editId}
      loading={loading || commentsLoading}
      {...props}
    />
  );
}

export { CommentsController as Comments };
